<template>
  <div>
    <!-- 商品明细 -->
    <el-dialog :title="$t('message.detailsOfGoods')" :close-on-click-modal="false"
      :visible.sync="$parent.detailsGoodsDialogVisible" width="1300px" center>
      <div class="content" ref="goodsDetails">
        <div class="table">
          <ol>
            <!-- 编号 -->
            <li class="flex2">{{ $t("message.transactionNumber") }}</li>
            <!-- 番号  -->
            <li>{{ $t("message.mash") }}</li>
            <!-- 店铺  -->
            <li>{{ $t("message.shop") }}</li>
            <!--  写真  -->
            <li>{{ $t("message.photo") }}</li>
            <!--  商品属性  -->
            <li class="flex15">{{ $t("message.commodityAttribute") }}</li>
            <!--  报价数据  -->
            <li>{{ $t("message.quoteData") }}</li>
            <!-- 实时价格 -->
            <li>{{ $t("message.realTimePrice") }}</li>
            <!-- 实时数量 -->
            <li>{{ $t("message.realTimeQuantity") }}</li>
            <!--  退换货数量  -->
            <li>{{ $t("message.quantityOfReturnAndReplacement") }}</li>
          </ol>
          <ul v-for="(item, index) in list" :key="index">
            <!--编号  -->
            <li class="flex2">{{ item.order_purchase.purchase_no }}</li>
            <!-- 番号  -->
            <li>{{ item.order_purchase.order_detail.sorting }}</li>
            <!--店铺信息  -->
            <li>
              <div class="template">
                <p>{{ item.order_purchase.order_detail.shop_name }}</p>
                <p style="color: #15ad3c">
                  {{ item.order_purchase.order_detail.from_platform }}
                </p>
                <p>{{ item.order_purchase.order_detail.shop_id }}</p>
              </div>
            </li>
            <!--照片  -->
            <li>
              <el-popover placement="right" width="300" trigger="hover">
                <img :src="item.order_purchase.order_detail.pic" alt="" style="width: 300px; height: 300px" />
                <a href="JavaScript:;" slot="reference">
                  <el-image :src="item.order_purchase.order_detail.pic"
                    style="width: 60px; height: 60px; border-radius: 4px">
                    <div slot="placeholder" class="image-slot">
                      加载中<span class="dot">...</span>
                    </div>
                  </el-image>
                </a>
              </el-popover>
            </li>
            <!--商品属性  -->
            <li class="flex15">
              <div class="attribute">
                <el-tooltip placement="bottom">
                  <div slot="content">
                    <div class="row" v-for="(itemDetail, itemIndex) in item.order_purchase
                      .order_detail.detail_y" :key="itemIndex" style="margin-bottom: 5px">
                      {{ itemDetail.key }}：{{ itemDetail.value }}
                    </div>
                  </div>
                  <div>
                    <div class="row" v-for="(itemDetail, itemIndex) in item.order_purchase
                      .order_detail.detail_y" :key="itemIndex">
                      {{ itemDetail.key }}：{{ itemDetail.value }}
                    </div>
                  </div>
                </el-tooltip>
              </div>
            </li>
            <!--  报价数据  -->
            <li>
              <div class="template">

                <!-- 数量 -->
                <p> {{ $t("message.quantity") }}：{{ item.order_purchase.order_detail.confirm_num }}</p>
                <!-- 单价 -->
                <p> {{ $t("message.unitPrice") }}：{{ item.order_purchase.order_detail.confirm_price }}</p>
                <!-- 运费 -->
                <p> {{ $t("message.freight") }}：{{ item.order_purchase.order_detail.confirm_freight }}</p>
              </div>

            </li>
            <!-- 实时价格 -->
            <li>
              <div class="template">
                <!-- 单价 -->
                <p> {{ $t("message.unitPrice") }}：{{ item.order_purchase.order_detail.offer_price_bak }}</p>
                <!-- 运费 -->
                <p> {{ $t("message.freight") }}：{{ item.order_purchase.order_detail.offer_freight_bak }}</p>
              </div>

            </li>
            <!-- 实时数量 -->
            <li>
              <div class="template">
                <!-- 可入库: -->
                <p> {{ $t("message.canBePutIntoStorage") }}：{{ item.order_purchase.storage_num }}</p>
                <!-- 已到货 -->
                <p> {{ $t("message.itHasArrived") }}：{{ item.order_purchase.possible_num }}</p>
              </div>
            </li>

            <!--退换货数量  -->
            <li>{{ item.num }}</li>
          </ul>
        </div>
      </div>
      <span slot="footer" class="dialog-footer" v-if="$route.name != 'exchangeList'">
        <!--  取 消  -->
        <el-button @click="$parent.detailsGoodsDialogVisible = false">
          {{ $t("message.cancel") }}
        </el-button>
        <!-- 打印 -->
        <el-button type="primary" @click="printGoodsDetails()">
          {{ $t("message.print") }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    list: { type: Array },
  },
  data() {
    return {};
  },
  created() {
    console.log(this.list);
  },
  methods: {
    // 打印商品详情
    printGoodsDetails() {
      this.$print(this.$refs.goodsDetails);
      this.$parent.detailsGoodsDialogVisible = false
    }
  },
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0 15px;
  padding: 24px;
  background: #f8f8f8;
  border-radius: 8px;

  ul {
    padding: 24px 0;
  }

  .flex15 {
    flex: 1.5;
  }

  .flex2 {
    flex: 2;
  }

  .template {
    text-align: center;
  }
}
</style>